import sanitizer from 'sanitize-html';
import _isString from 'lodash/isString';

const ALLOWED_ATTRIBUTES = {
  h1: ['id', 'class', 'style'],
  h2: ['id', 'class', 'style'],
  h3: ['id', 'class', 'style'],
  h4: ['id', 'class', 'style'],
  h5: ['id', 'class', 'style'],
  h6: ['id', 'class', 'style'],
  strong: ['id', 'class', 'style'],
  b: ['id', 'class', 'style'],
  em: ['id', 'class', 'style'],
  u: ['id', 'class', 'style'],
  s: ['id', 'class', 'style'],
  strike: ['id', 'class', 'style'],
  i: ['id', 'class', 'style'],
  span: ['id', 'class', 'style'],
  sup: ['id', 'class', 'style'],
  sub: ['id', 'class', 'style'],
  code: ['id', 'class', 'style'],
  p: ['id', 'class', 'style'],
  div: ['id', 'class', 'style'],
  pre: ['id', 'class', 'style'],
  blockquote: ['id', 'class', 'style', 'cite'],
  ul: ['id', 'class', 'style'],
  ol: ['id', 'class', 'style'],
  li: ['id', 'class', 'style'],
  a: ['id', 'class', 'style', 'href', 'name', 'target', 'title', 'rel'],
  table: ['id', 'class', 'style'],
  thead: ['id', 'class', 'style'],
  caption: ['id', 'class', 'style'],
  tbody: ['id', 'class', 'style'],
  th: ['id', 'class', 'style', 'scope', 'colspan', 'rowspan'],
  tr: ['id', 'class', 'style'],
  td: ['id', 'class', 'style', 'colspan', 'rowspan'],
  br: ['id', 'class', 'style'],
  hr: ['id', 'class', 'style'],
  img: ['id', 'class', 'style', 'src', 'alt', 'title', 'width', 'height'],
  video: [
    'id',
    'class',
    'style',
    'src',
    'width',
    'height',
    'controls',
    'autoplay',
    'muted',
    'loop'
  ],
  source: ['id', 'class', 'style', 'src', 'type']
};

export default function sanitizeHtml(html = '') {
  if (!_isString(html)) return '';

  return sanitizer(html, {
    allowedTags: Object.keys(ALLOWED_ATTRIBUTES),
    allowedAttributes: ALLOWED_ATTRIBUTES,
    // Explicitly disallow all event handler attributes (on*)
    disallowedTagsMode: 'discard',
    allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
    allowedSchemesByTag: {
      img: ['http', 'https', 'data']
    },
    // Additional security: remove any attributes starting with "on"
    transformTags: {
      '*': function(tagName, attributes) {
        const filteredAttribs = {};
        for (const [key, value] of Object.entries(attributes)) {
          const isHref = key.toLowerCase() === 'href';
          const isEventHandler = key.toLowerCase().startsWith('on');
          const isJSProtocol =
            isHref &&
            _isString(value) &&
            value
              .trim()
              .toLowerCase()
              .startsWith('javascript:'); // eslint-disable-line no-script-url
          if (!isEventHandler && !isJSProtocol) {
            filteredAttribs[key] = value;
          }
        }
        return {
          tagName,
          attribs: filteredAttribs
        };
      }
    }
  });
}
